import { call, put, select } from 'redux-saga/effects'
import notification from '../../helpers/notification'
import _ from 'lodash'
import { mutate } from 'swr';

export type Options = {
    payload: any | undefined
    successMessage?: string
    errorMessage?: string
    hideErrorMessage?: boolean
    forceRefreshKey?: string
}

export function* execFillRequest(
    request: any,
    success: any,
    failure: any,
    options: Options
) {
    try {
        const response = yield call(request, ...options.payload)
        yield put(success(response.data))
        if(options.successMessage){
            notification.sucess(options.successMessage!)
        }
        if(options.forceRefreshKey){
            yield call(mutate, options.forceRefreshKey!)
        }
    } catch (error) {
        yield put(failure(error))
        if(!options.hideErrorMessage){
            const msg = _.isEmpty(options.errorMessage)
            ? 'Une erreur est survenue, veuillez réessayez ultérieurement'
            : options.errorMessage
            notification.error(msg!)
        }
    }
}

export function* execSaveRequest(
    create: any,
    update: any,
    success: any,
    failure: any,
    options: Options
) {
    const botId = yield select(state => state.bot.selectedBot)
    try {
        if (options.payload.id) {
            const response = yield call(update, botId, options.payload)
            yield put(success(options.payload))
        } else {
            const response = yield call(create, botId, options.payload)
            yield put(success(response.data))
        }
        notification.sucess(options.successMessage!)
    } catch (error) {
        yield put(failure(error))
        const msg = _.isEmpty(options.errorMessage)
            ? 'Une erreur est survenue, veuillez réessayez ultérieurement'
            : options.errorMessage
        notification.error(msg!)
    }
}
